import type { IConfigStore } from '../interfaces/store-config.interface';
import type {
  IAddFilesConfig,
  IWidgetFeature,
} from '../interfaces/widget-feature.interface';
import { WidgetFeatureType } from '../enums/widget-feature.enum';

/** Returns the feature entry from the config's `features` array, if present. */
export const getFeature = (
  config: IConfigStore,
  feature: WidgetFeatureType
): IWidgetFeature | undefined =>
  config.features?.find((f) => f.name === feature);

/** Returns true when the given feature exists and is enabled. */
export const isFeatureEnabled = (
  config: IConfigStore,
  feature: WidgetFeatureType
): boolean => getFeature(config, feature)?.enabled ?? false;

/** Returns the list of currently enabled features. */
export const getEnabledFeatures = (config: IConfigStore): IWidgetFeature[] =>
  config.features?.filter((f) => f.enabled) ?? [];

/** Returns the addFiles (isAddFiles) feature config, if configured. */
export const getAddFilesConfig = (
  config: IConfigStore
): IAddFilesConfig | undefined =>
  getFeature(config, WidgetFeatureType.addFiles)?.customConfig as
    | IAddFilesConfig
    | undefined;
